export const FormatDateString = (date: string | Date) => {
  const parsedDate = date instanceof Date ? date : new Date(Date.parse(date));
  const d = Intl.DateTimeFormat("en-GB", {
    dateStyle: "full",
    timeStyle: "long",
    timeZone: "UTC",
  }).format(parsedDate);
  return `${d}`;
};